// @Version: 1.0.0
import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root'
})

export class AndOrOptionService {

   constructor() { }

   public equalsXAND (compareValue: string[], validValue: string[]): boolean {
      return JSON.stringify(compareValue.sort()) == JSON.stringify(validValue.sort()) ? true : false;
   }

   public containsAND (compareValue: string[], validValue: string[]): boolean {
      return JSON.stringify(compareValue.sort().filter(item => validValue.findIndex(itemValid => itemValid == item) > -1)) == JSON.stringify(validValue.sort()) ? true : false;
   }

   public containsOneOR (compareValue: string[], validValue: string[]): boolean  {
      return this.containsAND(compareValue, validValue) || compareValue.filter(item => validValue.findIndex(itemValid => itemValid == item) > -1).length > 0  ? true : false;
   }

   public containsOnlyOneXOR (compareValue: string[], validValue: string[]): boolean {
      return this.equalsXAND(compareValue, validValue) || compareValue.filter(item => validValue.findIndex(itemValid => itemValid == item) > -1).length > 0 && compareValue.filter(item => validValue.findIndex(itemValid => itemValid == item) == -1).length == 0 ? true : false;
   }
}